<template>
    <!-- TODO css -->
    <modal @close="modals.giftBoxCampaignsMultiModal = false">
        <div v-if="screen === 'form'">
            <h3 v-if="type=='send'">Select & Send - Multiple Recipients</h3>
            <h3 v-if="type=='link'">Create A New Invitation - Multiple</h3>
            <div class="large-form">
                <div class="form-line" v-if="type=='link'" style="text-align: left">
                    <div class="form-field"><b>To generate a gift registration link for multiple recipients at once</b>, please upload a CSV with invitee's <i>email addresses</i> (required) and their <i>names</i> (not required).</div>
                </div>

                <div class="form-line" v-if="type=='send'">
                    <div class="form-field" style="width: 70%">
                        <label>Gift Box Option *</label>
                        <select v-model="item.option_id" required>
                            <option value="null">- Choose -</option>
                            <option v-for="o in campaign.options" :value="o.id" v-if="o.enabled && o.type=='physical'">{{ o.name }}</option>
                            <option v-for="o in campaign.options" :value="o.id" v-if="o.enabled == false || o.type=='voucher'" disabled>{{ o.name }} (N/A)</option>
                        </select>
                        <div v-if="campaign.reward_type=='mixed'" class="field-note">You can only use this tool to multi-send active physical gifts that you have on stock.</div>
                    </div>
                </div>
                
                <div class="form-line"  style="position:relative;">
                    <div class="form-line-fields" style="width: 100%;">
                        <div id="form-field-base" class="form-field form-field-image-upload">
                            <label>CSV ADDRESS FILE *</label>
                            <div @click="$refs.csvUploadInput.click()" class="ws-button">Upload CSV File</div>
                            
                            <div class="file-upload-action-links">
                                <a v-if="type==='link'" title="Download the CSV template." class="action action-download" href="/wp-content/plugins/worksends/files/ws-multilink-template.csv" download>DOWNLOAD CSV TEMPLATE</a>
                                <a v-if="type==='send'" title="Download the CSV template." class="action action-download" href="/wp-content/plugins/worksends/files/ws-multisend-template.csv" download>DOWNLOAD CSV TEMPLATE</a>
                                <div title="Read how to properly fill out the CSV File." class="action" @click="showUploadInstructions = true">CSV FILE INSTRUCTIONS</div>
                            </div>

                            <div v-if="csvFile" class="file-upload-file">{{ csvFile.name }}</div>
                            <input ref="csvUploadInput" accept="text/csv" style="display: none" type="file" @change="onCsvChange">
                        </div>
                        
                    </div>
                </div>
                
                <div class="form-line">
                    <div class="form-field">
                        <label>List Name *</label>
                        <div v-if="batch && batch.shared_secret" class="form-static-field"><b>{{ item.batch_label }}</b></div>
                        <div v-else>
                            <input v-model="item.batch_label" maxlength="100" required>
                            <div class="field-note">Your internal name for this batch of invitations.</div>
                        </div>
                    </div>
                </div>
                
                <field-notecard :item="item" :campaign="campaign" v-if="campaign.reward_type=='physical'"></field-notecard>
            
                <div class="form-line" >
                  <div class="form-field form-field-radio" >
                      <label>Inform the recipient</label>
                      <div class="radio-option">
                        <input v-model="item.send_email" type="radio" value="false">
                        <span class="radio-label" v-if="type=='send'">No, do not send order updates to the recipient</span>
                        <span class="radio-label" v-else>No, I will share the link with the recipients manually</span>
                      </div>
                      <div class="radio-option">
                        <input v-model="item.send_email" type="radio" value="true">
                        <span class="radio-label" v-if="type=='send'">Yes, send summary and tracking emails to the recipient</span>
                        <span class="radio-label" v-else>Yes, send an email with the gift claim link to each recipient</span>
                      </div>
                  </div>
                  
                  <div class="form-field form-field-checkbox" v-if="item.send_email==true || item.send_email=='true'" >
                      <label>Custom Email Text</label>
                      <div class="checkbox-option">
                        <input v-model="item.custom_email_message" type="checkbox">
                        <span class="checkbox-label">Add custom text to info email.</span>
                      </div>  
                      <textarea v-if="item.send_email && item.custom_email_message" v-model="item.invitation_message" placeholder="Write your custom email info message here." rows="6" maxlength="1015"></textarea>
                  </div>
                </div>
                
                <div class="form-line" v-if="type=='link'">
                    <div class="form-field">
                        <div class="small-note">You will recieve <b>multi gift claim URL that can be used by all</b> of the invitees in this list to claim the gift. The email adress they use to claim the gift must match the one from the CSV file.
                        </div>
                    </div>
                </div>

                
                <div class="modal-errors">
                    <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>                
                </div>
                
                <div v-if="!userCanCheckout" class="small-note error">
                    <b>You don't have access to team credit.</b> You need to contact your <i>Team Manager</i> to enable you team credit to continue with this operation.
                </div>
            </div>
            <div class="form-actions">
                <div class="ws-button ws-button-secondary" data-action="cancel" @click="modals.giftBoxCampaignsMultiModal = false">Cancel</div>
                <div v-if="userCanCheckout && type=='send'" class="ws-button ws-button-main" @click="sendGifts">Send Gifts</div>
                <div v-if="userCanCheckout && type=='link'" class="ws-button ws-button-main" @click="sendGifts">Create Invitations</div>
            </div>
        </div>
        
        <!-- Order Prgcessing -->
        <div v-else-if="screen === 'processing'">
            <div class="ws-form-processing"><div class="value-loader"></div><p>We are processing your request. <br>Please give us a moment...</p></div>
        </div>
            
        <!-- Link Info Window -->
        <div v-else-if="screen === 'details'">
            <h3>Campaign Invitations Created</h3>
            <div class="large-form">
                  <div class="form-line">
                      <h4 v-if="details.is_multi && details.batch_label" style="margin-top: 0">Multi invite batch: <b>{{ details.batch_label }}</b></h4>
                      <p>Your unique gift registration link has been generated. You can copy it below and share it to your invitees.</p>
                      <p><a :href="details.invite_link" target="_blank">{{ details.invite_link }}</a></p>
                      <div style="margin: 20px auto"><span class="ws-button ws-button-main" @click="copyToClipboard(details.invite_link)">COPY GIFT REGISTRATION LINK</span></div>
                      <p>To claim the gift each invitee needs to register using the same email address as provided.</p>
                  </div>
            </div>
            <div class="form-actions">
                <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.giftBoxCampaignsMultiModal = false">CLOSE</span>
            </div>
        </div>
        <modal v-if="showUploadInstructions" @close="showUploadInstructions = false" width="400px">
            <h3>CSV File Upload Instructions</h3>
            <ul id="upload-instructions">
                <li>Download the CSV template to see how to format your CSV file</li>
                <li>Keep the first header column in the CSV file exactly as it is in the template</li>
                <li>Use single comma (,) to separate values</li>
                <li>For countries, use <a href="https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements" target="_blank">2-letter ISO country codes</a> only</li>
                <li>Avoid using special characters including brackets, forward slashes, punctuation or letters with accents</li>
                <li>If you receive an error message please check that none of the cells in your CSV contain any of these characters or excess spaces</li>
            </ul>
            <div class="form-actions">
                <span class="ws-button ws-button-secondary" data-action="cancel" @click="showUploadInstructions = false">ACKNOWLEDGED</span>
            </div>
        </modal>
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";
import FieldNotecard from "@/components/FieldNotecard";

export default {
    name: "GiftBoxCampaignsEditModal",
    components: {Modal,FieldNotecard},
    props: {
        campaignId: Number,
        fetchItem: {type: Boolean, default: false},
        type: String,
        batch: Object,
    },
    data() {
        return {
            screen: 'form',
            item: {option_id:null, batch_label: '', notecard_type:'default', notecard_text:'', send_email: false, custom_email_message: false, invitation_message:'', shared_secret: '', send_email: false},
            details: {invite_link: null},
            csvFile:null,
            showUploadInstructions: false,
            errors: {},
        }
    },
    methods: {
        async sendGifts() {
            if (!this.demoCheck()) return;
            
            if (this.$wait.is('CSVMultiSend') || this.$wait.is('CSVMultiLink')) return;

            var validateFields = [
                { name: 'CSV File ', value: this.csvFile, rules: ['required'] },
                { name: 'List Label', value: this.item.batch_label, rules: ['required'] },
            ];
            if (this.type=='send') {
                validateFields.push({ name: 'Gift Box Option', value: this.item.option_id, rules: ['required'] });
            }
            
            this.errors = this.validateFields(validateFields);
            if (Object.keys(this.errors).length) return;
            
            this.screen = 'processing';
            if (this.item.send_email == 'true') this.item.send_email = true;
            if (this.item.send_email == 'false') this.item.send_email = false;
            
            const formData = new FormData();
            ['option_id','batch_label','notecard_type','notecard_text','send_email','invitation_message','shared_secret'].forEach(key => formData.append(key, this.item[key]));
            formData.append('csv', this.csvFile)
            
            try {
                if (this.type=='send') {
                    await this.dispatchWaitAndNotify('CSVMultiSend', {campaignId: this.campaignId, payload: formData});
                    this.$emit('sent');
                }
                else if (this.type=='link') {
                    this.details = await this.dispatchWaitAndNotify('CSVMultiLink', {campaignId: this.campaignId, payload: formData});
                    this.$emit('sent');
                    this.screen = 'details';
                }
            } catch (e) {
                this.screen = 'form';
                return;
            }
        },
        onCsvChange(event) {
            this.csvFile = event.target.files[0];
        },
        copyToClipboard(text) {
            const el = document.createElement('textarea');
            el.value = text;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            this.notifyStatus(200, 'Link Copied', 'The link has been copied to your clipboard.');
    	},
    },
    async mounted() {
        if (!this.proCheck('Sending campaign invites')) {
            this.modals.giftBoxCampaignsMultiModal = false;
            return;
        }
        
        if (this.fetchItem) {
            await this.dispatchWaitAndNotify('fetchGiftBoxCampaign', {campaignId: this.item.id}, false, true);
        }
        if (!this.campaign.notecard_text) this.item.notecard_type = 'none';
        if (this.batch && this.batch.shared_secret) {
            this.item.batch_label = this.batch.label;
            this.item.shared_secret = this.batch.shared_secret;
        }
    },
    computed: {
        campaign() {
            return this.$store.state.giftBoxCampaign.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
        user() {
            return this.$store.state.currentUser;
        },
        userCanCheckout() {
            return this.user.permissions && this.user.permissions.includes('use-balance');
        },
    }
}
</script>

<style scoped>

</style>